import axiosInstance from "../configs/axios";
import {route} from "ziggy-js";
import {showToast} from './toast';
import {Toast} from '../consts/toast';
import {trackEvent} from "../tracking/gtm";
import {trans} from "../i18n/i18n";

const DIALOG_CONTAINER = ".js-cookie-consent-container";
const DIALOG_MAIN = ".js-cookie-consent";
const DIALOG_MANAGE = ".js-cookie-consent-manage-dialog";
const BUTTON_ACCEPT = ".js-cookie-consent-agree";
const BUTTON_REJECT = ".js-cookie-consent-disagree";
const BUTTON_MANAGE = ".js-cookie-consent-manage";
const LINK_REVIEW_CHOICES = ".js-review-cookie-choices";

const acceptRoute = route('cookie.consent.accept');
const rejectRoute = route('cookie.consent.reject');

$(document)
  .on("click", LINK_REVIEW_CHOICES, function (e) {
    e.preventDefault();
    loadCookieConsentDialog();
  })
  .on("click", BUTTON_MANAGE, function () {
    $(DIALOG_MAIN).addClass("d-none");
    $(DIALOG_MANAGE).removeClass("d-none");
  })
  .on("click", BUTTON_ACCEPT, function () {
    storeCookieConsent(acceptRoute);
    trackCookieConsent("granted");
  })
  .on("click", BUTTON_REJECT, function () {
    storeCookieConsent(rejectRoute);
    trackCookieConsent("denied");
  });

function loadCookieConsentDialog() {
  axiosInstance.get(route('cookie.consent.dialog'))
    .then(({ data }) => {
      if (data.html) {
        $('body').prepend(data.html);
        $(DIALOG_MAIN).removeClass("d-none");
        $(DIALOG_MANAGE).addClass("d-none");
      }
    })
    .catch(() => showToast(trans("Failed to load cookie settings."), Toast.ERROR));
}

function storeCookieConsent(url) {
  const $cookieConsentContainer = $(DIALOG_CONTAINER);

  $(`${BUTTON_ACCEPT}, ${BUTTON_REJECT}, ${BUTTON_MANAGE}`).addClass("is-disabled").attr("disabled", "disabled");

  axiosInstance.post(url)
    .then(({ data }) => {
      if (data?.reload) {
        window.location.reload();
        return;
      }
    })
    .catch(() => showToast(trans("Failed to save your preferences."), Toast.ERROR))
    .finally(() => $cookieConsentContainer.remove());
}

function trackCookieConsent(status) {
  trackEvent(
    "consent_updated",
    {
      consent: {
        "ad_user_data": status,
        "ad_personalization": status,
        "ad_storage": status,
        "analytics_storage": status,
        "functionality_storage": "granted",
        "personalization_storage": status,
        "security_storage": "granted",
      }
    }
  );
}
